// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IEmployeeContributionDto } from './IEmployeeContributionDto';
import {
    IEmployeeContributionDtoFromJSON,
    IEmployeeContributionDtoFromJSONTyped,
    IEmployeeContributionDtoToJSON,
    IEmployeeContributionDtoToJSONTyped,
} from './IEmployeeContributionDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageEmployeeContributionDto
 */
export interface IPageEmployeeContributionDto {
    /**
     * 
     * @type {number}
     * @memberof IPageEmployeeContributionDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageEmployeeContributionDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageEmployeeContributionDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IEmployeeContributionDto>}
     * @memberof IPageEmployeeContributionDto
     */
    content?: Array<IEmployeeContributionDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageEmployeeContributionDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageEmployeeContributionDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageEmployeeContributionDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageEmployeeContributionDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageEmployeeContributionDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageEmployeeContributionDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageEmployeeContributionDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageEmployeeContributionDto interface.
 */
export function instanceOfIPageEmployeeContributionDto(value: object): value is IPageEmployeeContributionDto {
    return true;
}

export function IPageEmployeeContributionDtoFromJSON(json: any): IPageEmployeeContributionDto {
    return IPageEmployeeContributionDtoFromJSONTyped(json, false);
}

export function IPageEmployeeContributionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageEmployeeContributionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IEmployeeContributionDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageEmployeeContributionDtoToJSON(json: any): IPageEmployeeContributionDto {
    return IPageEmployeeContributionDtoToJSONTyped(json, false);
}

export function IPageEmployeeContributionDtoToJSONTyped(value?: IPageEmployeeContributionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IEmployeeContributionDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

